
export default {
  props: {
    product: {
      type: Object,
      default: null
    },
    taxonLink: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    title() {
      return {
        tag: 'h4',
        html: this.product.name,
        font: 'source'
      }
    },
    image() {
      return {
        fit: 'cover',
        ratio: 'square',
        ...this.productImage
      }
    },
    productImage() {
      return this.product.image
        ? this.product.image
        : { src: '/no-image.png', fit: 'contain' }
    },
    detailsLink() {
      const products = this.$pagePath('products')
      return `${products}/${this.product.slug}`
    },
    showLink() {
      return this.product.variantsCount > 0 || this.product.totalOnHand < 1
    }
  }
}
